// extracted by mini-css-extract-plugin
export default {"assetHistoryProfileContainer":"AssetHistoryProfile_assetHistoryProfileContainer__DOt9c"};